(function () {
  'use strict';

  var WANDLY_MOBILE_MAX = 700;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function initGallery(section) {
    if (
      section.dataset.wandlyPdpCleanReady === 'true' ||
      section.dataset.wandlyGalleryReady === 'true' ||
      section.dataset.wandlyGlobalGalleryReady === 'true'
    ) {
      return;
    }

    var mainImage = section.querySelector('[data-wandly-main-image]');
    var media = section.querySelector('[data-wandly-media]');
    var previousButton = section.querySelector('[data-wandly-prev]');
    var nextButton = section.querySelector('[data-wandly-next]');
    var thumbs = toArray(section.querySelectorAll('[data-wandly-thumb]'));

    if (!mainImage || !thumbs.length) {
      return;
    }

    section.dataset.wandlyGlobalGalleryReady = 'true';

    var activeIndex = thumbs.findIndex(function (thumb) {
      return thumb.classList.contains('is-active');
    });

    if (activeIndex < 0) activeIndex = 0;

    function showImage(index) {
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;

      activeIndex = index;

      thumbs.forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle('is-active', thumbIndex === activeIndex);
      });

      var imageUrl = thumbs[activeIndex].getAttribute('data-image');
      if (!imageUrl) return;

      mainImage.classList.add('is-changing');

      var preload = new Image();
      preload.onload = function () {
        mainImage.src = imageUrl;
        window.requestAnimationFrame(function () {
          mainImage.classList.remove('is-changing');
        });
      };
      preload.onerror = function () {
        mainImage.classList.remove('is-changing');
      };
      preload.src = imageUrl;

      try {
        thumbs[activeIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      } catch (error) {
        thumbs[activeIndex].scrollIntoView(false);
      }
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        showImage(index);
      });
    });

    if (previousButton) {
      previousButton.addEventListener('click', function () {
        showImage(activeIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        showImage(activeIndex + 1);
      });
    }

    if (media && thumbs.length > 1) {
      var startX = 0;
      var startY = 0;

      media.addEventListener(
        'touchstart',
        function (event) {
          if (!event.touches || event.touches.length !== 1) return;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        },
        { passive: true }
      );

      media.addEventListener(
        'touchend',
        function (event) {
          if (!event.changedTouches || !event.changedTouches.length) return;

          var deltaX = event.changedTouches[0].clientX - startX;
          var deltaY = event.changedTouches[0].clientY - startY;

          if (
            Math.abs(deltaX) < 45 ||
            Math.abs(deltaX) < Math.abs(deltaY) * 1.2
          ) {
            return;
          }

          showImage(deltaX < 0 ? activeIndex + 1 : activeIndex - 1);
        },
        { passive: true }
      );
    }
  }

  function initAddToCart(section) {
    // Keep the template's own complete handler when it exists. This avoids
    // duplicate /cart/add requests and therefore duplicate cart/tracking events.
    if (
      section.dataset.wandlyPdpCleanReady === 'true' ||
      section.dataset.wandlyGlobalAtcReady === 'true'
    ) {
      return;
    }

    var addButton = section.querySelector('[data-wandly-add]');
    if (!addButton) return;

    section.dataset.wandlyGlobalAtcReady = 'true';

    addButton.addEventListener('click', function () {
      if (addButton.disabled || addButton.classList.contains('is-loading')) {
        return;
      }

      var variantId = addButton.getAttribute('data-variant-id');
      if (!variantId) return;

      addButton.classList.add('is-loading');
      addButton.disabled = true;

      var addUrl =
        window.routes && window.routes.cart_add_url
          ? window.routes.cart_add_url
          : ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Toevoegen mislukt');
          return response.json();
        })
        .then(function () {
          addButton.classList.remove('is-loading');
          addButton.disabled = false;

          if (
            window.WandlyCartDrawer &&
            typeof window.WandlyCartDrawer.open === 'function'
          ) {
            window.WandlyCartDrawer.open();
          } else {
            window.location.href =
              window.routes && window.routes.cart_url
                ? window.routes.cart_url
                : ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
          }
        })
        .catch(function () {
          addButton.classList.remove('is-loading');
          addButton.disabled = false;
        });
    });
  }

  function appendIf(parent, node) {
    if (parent && node) parent.appendChild(node);
  }

  function ensureMobileState(section) {
    var layout = section.querySelector('.wandly-pdp-clean__layout');
    var left = section.querySelector('.wandly-pdp-clean__left');
    var panel = section.querySelector('.wandly-pdp-clean__panel');

    if (!layout || !left || !panel) return null;

    if (!section.__wandlyMobileOrder) {
      section.__wandlyMobileOrder = {
        left: left,
        panel: panel,
        leftChildren: toArray(left.children),
        panelChildren: toArray(panel.children),
        flow: null,
        mobile: false
      };
    }

    return section.__wandlyMobileOrder;
  }

  function enforceMobileOrder(section) {
    var state = ensureMobileState(section);
    if (!state) return;

    var layout = section.querySelector('.wandly-pdp-clean__layout');
    var mobile = window.innerWidth <= WANDLY_MOBILE_MAX;

    if (!mobile) {
      if (state.mobile || state.flow) {
        state.leftChildren.forEach(function (node) {
          state.left.appendChild(node);
        });
        state.panelChildren.forEach(function (node) {
          state.panel.appendChild(node);
        });

        var oldFlow = state.flow || section.querySelector('.wandly-pdp-clean__mobile-flow');
        if (oldFlow && oldFlow.parentNode) oldFlow.parentNode.removeChild(oldFlow);

        layout.classList.remove('is-mobile-reordered');
        state.flow = null;
        state.mobile = false;
      }
      return;
    }

    var flow = state.flow || section.querySelector('.wandly-pdp-clean__mobile-flow');
    if (!flow) {
      flow = document.createElement('div');
      flow.className = 'wandly-pdp-clean__mobile-flow';
      layout.appendChild(flow);
    }

    flow.setAttribute('data-wandly-mobile-layout', 'saliegroen-60-final');

    var review = section.querySelector('.wandly-pdp-clean__review');
    var title = section.querySelector('.wandly-pdp-clean__title');
    var media = section.querySelector('.wandly-pdp-clean__media');
    var thumbs = section.querySelector('.wandly-pdp-clean__thumbs');
    var benefits = section.querySelector('.wandly-pdp-clean__benefits');
    var selectors = section.querySelector('.wandly-pdp-clean__selectors');
    var purchaseCard = section.querySelector('.wandly-pdp-clean__purchase-card');
    var specs = section.querySelector('.wandly-pdp-clean__specs-card');
    var accordions = section.querySelector('.wandly-pdp-clean__accordions');
    var related = section.querySelector('.wandly-pdp-clean__related');

    appendIf(flow, review);
    appendIf(flow, title);
    appendIf(flow, media);
    appendIf(flow, thumbs);

    // Price is shown separately on mobile, directly under the gallery.
    var existingMobilePrice = flow.querySelector('.wandly-pdp-clean__mobile-price-row');
    if (existingMobilePrice) existingMobilePrice.remove();

    if (purchaseCard) {
      var originalPrice = purchaseCard.querySelector('.wandly-pdp-clean__price-row');
      if (originalPrice) {
        var priceClone = originalPrice.cloneNode(true);
        priceClone.classList.add('wandly-pdp-clean__mobile-price-row');
        appendIf(flow, priceClone);
      }
    } else {
      // Older Wandly templates have the purchase elements directly in the panel.
      var standalonePrice = section.querySelector('.wandly-pdp-clean__price-row');
      appendIf(flow, standalonePrice);
    }

    appendIf(flow, benefits);
    appendIf(flow, selectors);

    if (purchaseCard) {
      appendIf(flow, purchaseCard);
    } else {
      appendIf(flow, section.querySelector('.wandly-pdp-clean__add'));
      appendIf(flow, section.querySelector('.wandly-pdp-clean__payment-options'));
      appendIf(flow, section.querySelector('.wandly-pdp-clean__stock'));
    }

    appendIf(flow, specs);
    appendIf(flow, accordions);
    appendIf(flow, related);

    layout.classList.add('is-mobile-reordered');
    state.flow = flow;
    state.mobile = true;
  }

  function initWandlyPdpFixes(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var sections = toArray(root.querySelectorAll('[data-wandly-pdp-clean]'));

    if (root.matches && root.matches('[data-wandly-pdp-clean]')) {
      sections.unshift(root);
    }

    sections.forEach(function (section) {
      initGallery(section);
      initAddToCart(section);
      enforceMobileOrder(section);
    });
  }

  var resizeTimer;
  function handleResize() {
    window.clearTimeout(resizeTimer);
    // The old Saliegroen-60 template also has an 80ms resize handler. Running
    // after it makes this global layout authoritative without replacing the
    // product-specific template code.
    resizeTimer = window.setTimeout(function () {
      initWandlyPdpFixes(document);
    }, 130);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWandlyPdpFixes(document);
    });
  } else {
    initWandlyPdpFixes(document);
  }

  window.addEventListener('resize', handleResize, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    window.setTimeout(function () {
      initWandlyPdpFixes(event.target);
    }, 0);
  });
})();
